import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons'

import type { NotificationConfig } from './types'

export const NOTIFICATION_DURATION = 8
export const NOTIFICATION_LIMIT = 3

export const NOTIFICATION_CONFIG = {
  info: { icon: faCircleInfo },
  success: { icon: faCircleCheck },
  error: { icon: faCircleExclamation },
  warning: { icon: faTriangleExclamation }
} as const satisfies Record<string, NotificationConfig>
